
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { ENVIRONMENT } from '../../environments/environment';

import { BaseService } from './base.service';

@Injectable()
export class BankIntegrationService {
    constructor(
        private baseService: BaseService,
    ) {
    }

    getBniAccountDetail(): Observable<any> {
        const endPoint = `${ENVIRONMENT.service.bankIntegrationService}/v1/bni/accounts/me`;
        return this.baseService.get(endPoint);
    }

}


